import type { IChannelState } from 'src/types/checkout';

export const buildChannelFormData = (state: IChannelState) => {
  const { channelType, channelName, emailProviderType } = state;

  const builders: Record<string, () => any> = {
    WHATSAPP: () => ({
      channelName,
      channelType,
      code: state.facebookDetails.main_token,
      pin: state.whatsappPin,
    }),
    MESSENGER: () => ({
      channelName,
      channelType,
      code: state.facebookDetails.main_token,
    }),
    INSTAGRAM: () => ({
      channelName,
      channelType,
      code: state.facebookDetails.main_token,
    }),
    LIVE_CHAT: () => ({
      channelName: state.LiveChatDeatil.websiteName,
      channelType,
      domainUrl: state.LiveChatDeatil.websiteDomin,
      welcomeTagline: state.LiveChatDeatil.welcomeTagline,
      welcomeTitle: state.LiveChatDeatil.welcomeTitle,
      widgetColor: state.LiveChatDeatil.widgetColor,
    }),
    TELEGRAM: () => ({
      channelName,
      channelType: 'TELEGRAM',
      botToken: state.telegramBotToken,
    }),
    VOICE: () => ({
      channelName,
      channelType: 'VOICE',
      didNum: state.voiceCallDetails.didNum,
      didType: state.voiceCallDetails.didType,
    }),
    LINE: () => ({
      channelName: state.lineDetails.lineChannelName || '',
      channelType: 'LINE',
      lineChannelSecret: state.lineDetails.lineChannelSecret || '',
      lineChannelId: state.lineDetails.lineChannelId || '',
    }),
    MICROSOFTTEAMS: () => ({
      channelName,
      channelType: 'MICROSOFTTEAMS',
      code: state.microsoftTeamsDetails.code,
    }),
    EMAIL: () => {
      if (emailProviderType === 'other_provider') {
        const { smtpDetails, imapDetails, emailChannelDtls } = state;
        return {
          channelName: emailChannelDtls.channelName,
          email: emailChannelDtls.email,
          channelType: 'EMAIL',
          provider: 'other',
          ...smtpDetails,
          ...imapDetails,
        };
      }
      const code =
        emailProviderType === 'google'
          ? state.googleEmailDetails.code
          : state.microsoftEmailDetails.code;
      return {
        channelName: state.emailChannelDtls.channelName,
        provider: emailProviderType,
        channelType: 'EMAIL',
        code,
      };
    },
    SMS: () => ({
      channelName,
      provider: state.SMSProviderType,
      channelType: 'SMS',
      accountSid: state.smsChannelDtls?.accountSid || '',
      authToken: state.smsChannelDtls?.authToken || '',
      srcNumber: state.smsChannelDtls?.srcNumber || '',
    }),
  };

  return builders[channelType]?.() || null;
};
